import { IMatterRequest } from '../../interface/matterRequest';
import { buildEditDto, checkHasFieldsChanged } from '../../utils/matterRequestDtoBuilders';

export const isMatterRequestFormChanged = (
  matterRequest: IMatterRequest | null,
  initialMatterRequest: IMatterRequest | null,
  isEditMode: boolean,
): boolean => {
  if (isEditMode && initialMatterRequest) {
    return Object.keys(buildEditDto(matterRequest, initialMatterRequest)).length > 1;
  }
  return checkHasFieldsChanged(matterRequest);
};
